import Axios from "axios";
import Vue from "vue";
import i18n from "../../i18n";
import _ from 'lodash';
import { API_HOST } from "../../config/app-const";
import { normalize } from "../../helpers/pagination";
import { filtersToQuery } from "../../helpers/filters";

const state = {
  articleAssignmentRules: {
    isBusy: false,
    data: null,
    error: null
  },
  articleAssignmentRule: {
    isBusy: false,
    data: null,
    error: null
  },
  articleAssignmentTags: {
    isBusy: false,
    data: null,
    error: null
  },
  articleAssignmentPrivateTags: {
    isBusy: false,
    data: null,
    error: null
  },
  groups: {
    isBusy: false,
    data: null,
    error: null
  },
  articleAssignmentOutlets: {
    isBusy: false,
    data: null,
    error: null
  },
  relevancies: {
    isBusy: false,
    data: null,
    error: null
  },
  socialPostTypes: {
    isBusy: false,
    data: null,
    error: null
  },
  articleAssignmentAiModels: {
    isBusy: false,
    data: null,
    error: null
  }

};

const mutations = {
  LOAD_ARTICLE_ASSIGNMENT_RULES_BUSY: (state, payload) => {
    state.articleAssignmentRules.isBusy = payload;
  },
  LOAD_ARTICLE_ASSIGNMENT_RULES_SUCCESS: (state, payload) => {
    state.articleAssignmentRules.data = payload;
    state.articleAssignmentRules.error = null;
  },
  LOAD_ARTICLE_ASSIGNMENT_RULES_FAIL: (state, payload) => {
    state.articleAssignmentRules.error = payload;
    state.articleAssignmentRules.data = null;
  },

  LOAD_GROUPS_BUSY: (state, payload) => {
    state.groups.isBusy = payload;
  },
  LOAD_GROUPS_SUCCESS: (state, payload) => {
    state.groups.data = payload;
    state.groups.error = null;
  },
  LOAD_GROUPS_FAIL: (state, payload) => {
    state.groups.error = payload;
    state.groups.data = null;
  },

  LOAD_ARTICLE_ASSIGNMENT_RULE_BUSY: (state, payload) => {
    state.articleAssignmentRule.isBusy = payload;
  },
  LOAD_ARTICLE_ASSIGNMENT_RULE_SUCCESS: (state, payload) => {
    state.articleAssignmentRule.data = payload;
    state.articleAssignmentRule.error = null;
  },
  LOAD_ARTICLE_ASSIGNMENT_RULE_FAIL: (state, payload) => {
    state.articleAssignmentRule.error = payload;
    state.articleAssignmentRule.data = null;
  },
  CREATE_ARTICLE_ASSIGNMENT_RULE_BUSY: (state, payload) => {
    state.articleAssignmentRule.isBusy = payload;
  },
  CREATE_ARTICLE_ASSIGNMENT_RULE_SUCCESS: (state, payload) => {
    let newGroup = payload;
    const data = _.get(state.articleAssignmentRules, 'data.data.data') || _.get(state.articleAssignmentRules, 'data.data');
    if (data && _.isArray(data) && !data.find(g => g.id == newGroup.id)) {
      data.push(newGroup.data || newGroup);
    }
    
    state.articleAssignmentRule.data = newGroup;
    state.articleAssignmentRule.error = null;
  },
  CREATE_ARTICLE_ASSIGNMENT_RULE_FAIL: (state, payload) => {
    state.articleAssignmentRule.data = null;
    state.articleAssignmentRule.error = payload;
  },
  UPDATE_ARTICLE_ASSIGNMENT_RULE_BUSY(state, payload) {
    state.articleAssignmentRule.isBusy = payload;
  },
  UPDATE_ARTICLE_ASSIGNMENT_RULE_SUCCESS(state, payload) {
    let ruleToEdit = payload.data.id;
    const data = _.get(state.articleAssignmentRules, 'data.data.data') || _.get(state.articleAssignmentRules, 'data.data');

    state.articleAssignmentRules.data.data.data = data.map(rule => {
      if (rule.id === ruleToEdit.id) {
        return Object.assign({}, rule, ruleToEdit)
      }
      return rule
    });

    state.articleAssignmentRule.data = ruleToEdit;
    state.articleAssignmentRule.error = null;
  },
  UPDATE_ARTICLE_ASSIGNMENT_RULE_FAIL: (state, payload) => {
    state.articleAssignmentRule.error = payload;
    state.articleAssignmentRule.data = null;
  },
  DELETE_ARTICLE_ASSIGNMENT_RULE_BUSY: (state, payload) => {
    state.articleAssignmentRule.isBusy = payload;
  },
  DELETE_ARTICLE_ASSIGNMENT_RULE_SUCCESS: (state, payload) => {
    let ruleToRemove = payload;
    const data = _.get(state.articleAssignmentRules, 'data.data.data') || _.get(state.articleAssignmentRules, 'data.data');

    if (ruleToRemove.length > 0) {
      state.articleAssignmentRules.data.data.data = data.filter(a => !ruleToRemove.find(p => p === a.id));
    }
    else {
      const ruleIndex = data && _.isArray(data) && data.findIndex(g => g.id == payload);
      if(data && _.isArray(data) && !data.find(g => g.id == ruleToRemove.id)) {
        data.splice(ruleIndex, 1);
      }
    }

    state.articleAssignmentRule.data = ruleToRemove;
    state.articleAssignmentRule.error = null;
  },
  DELETE_ARTICLE_ASSIGNMENT_RULE_FAIL: (state, payload) => {
    state.articleAssignmentRule.error = payload;
    state.articleAssignmentRule.data = null;
  },

  LOAD_ARTICLE_ASSIGNMENT_TAGS_BUSY: (state, payload) => {
    state.articleAssignmentTags.isBusy = payload;
  },
  LOAD_ARTICLE_ASSIGNMENT_TAGS_SUCCESS: (state, payload) => {
    state.articleAssignmentTags.data = payload;
    state.articleAssignmentTags.error = null;
  },
  LOAD_ARTICLE_ASSIGNMENT_TAGS_FAIL: (state, payload) => {
    state.articleAssignmentTags.error = payload;
    state.articleAssignmentTags.data = null;
  },
  LOAD_ARTICLE_ASSIGNMENT_PRIVATE_TAGS_BUSY: (state, payload) => {
    state.articleAssignmentPrivateTags.isBusy = payload;
  },
  LOAD_ARTICLE_ASSIGNMENT_PRIVATE_TAGS_SUCCESS: (state, payload) => {
    state.articleAssignmentPrivateTags.data = payload;
    state.articleAssignmentPrivateTags.error = null;
  },
  LOAD_ARTICLE_ASSIGNMENT_PRIVATE_TAGS_FAIL: (state, payload) => {
    state.articleAssignmentPrivateTags.error = payload;
    state.articleAssignmentPrivateTags.data = null;
  },

  LOAD_ARTICLE_ASSIGNMENT_OUTLETS_BUSY: (state, payload) => {
    state.articleAssignmentOutlets.isBusy = payload;
  },
  LOAD_ARTICLE_ASSIGNMENT_OUTLETS_SUCCESS: (state, payload) => {
    state.articleAssignmentOutlets.data = payload;
    state.articleAssignmentOutlets.error = null;
  },
  LOAD_ARTICLE_ASSIGNMENT_OUTLETS_FAIL: (state, payload) => {
    state.articleAssignmentOutlets.error = payload;
    state.articleAssignmentOutlets.data = null;
  },

  LOAD_SOCIAL_POST_TYPE_BUSY: (state, payload) => {
    state.socialPostTypes.isBusy = payload;
  },
  LOAD_SOCIAL_POST_TYPE_SUCCESS: (state, payload) => {
    state.socialPostTypes.data = payload;
    state.socialPostTypes.error = null;
  },
  LOAD_SOCIAL_POST_TYPE_FAIL: (state, payload) => {
    state.socialPostTypes.error = payload;
    state.socialPostTypes.data = null;
  },

  LOAD_ARTICLE_AI_MODELS_BUSY: (state, payload) => {
    state.articleAssignmentAiModels.isBusy = payload;
  },
  LOAD_ARTICLE_AI_MODELS_SUCCESS: (state, payload) => {
    state.articleAssignmentAiModels.data = payload;
    state.articleAssignmentAiModels.error = null;
  },
  LOAD_ARTICLE_AI_MODELS_FAIL: (state, payload) => {
    state.articleAssignmentAiModels.error = payload;
    state.articleAssignmentAiModels.data = null;
  },
}

const actions = {
  getAssignmentRules: ({ commit, rootState }, { projectId, pagination }) => {
    commit("LOAD_ARTICLE_ASSIGNMENT_RULES_BUSY", true);

    let query = "?";
    const normalizedPagination = normalize(pagination);

    Object.keys(normalizedPagination).map((param, i) => {
      query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
    });

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign${query}`, config)
      .then(response => {
        commit("LOAD_ARTICLE_ASSIGNMENT_RULES_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_ASSIGNMENT_RULES_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_ASSIGNMENT_RULES_BUSY", false));
  },

  getAssignmentTags: ({ commit, rootState }, { projectId, pagination }) => {
    commit("LOAD_ARTICLE_ASSIGNMENT_TAGS_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign/tags`, config)
      .then(response => {
        commit("LOAD_ARTICLE_ASSIGNMENT_TAGS_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_ASSIGNMENT_TAGS_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_ASSIGNMENT_TAGS_BUSY", false));
  },

  getAssignmentPrivateTags: ({ commit, rootState }, { projectId, pagination }) => {
    commit("LOAD_ARTICLE_ASSIGNMENT_PRIVATE_TAGS_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign/private_tags`, config)
      .then(response => {
        commit("LOAD_ARTICLE_ASSIGNMENT_PRIVATE_TAGS_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_ASSIGNMENT_PRIVATE_TAGS_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_ASSIGNMENT_PRIVATE_TAGS_BUSY", false));
  },

  getAssignmentOutlets: ({ commit, rootState }, { projectId, pagination, filterValues }) => {
    commit("LOAD_ARTICLE_ASSIGNMENT_OUTLETS_BUSY", true);

    let query = "?";
    const normalizedPagination = normalize(pagination);

    Object.keys(normalizedPagination).map((param, i) => {
      query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
    });

    if (filterValues) {
      const filtersQuery = filtersToQuery(filterValues);
      if (filtersQuery != '') {
        query += '&' + filtersQuery;
      }
    }

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign/outlets${query}`, config)
      .then(response => {
        commit("LOAD_ARTICLE_ASSIGNMENT_OUTLETS_SUCCESS", response.data.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_ASSIGNMENT_OUTLETS_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_ASSIGNMENT_OUTLETS_BUSY", false));
  },

  getGroups: ({ commit, rootState }, projectId) => {
    commit("LOAD_GROUPS_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign/groups`, config)
      .then(response => {
        commit("LOAD_GROUPS_SUCCESS", response.data.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_GROUPS_FAIL", error);
      })
      .finally(() => commit("LOAD_GROUPS_BUSY", false));
  },

  getAssignmentRule: ({ commit, state, rootState }, { projectId, ruleId }) => {
    commit("LOAD_ARTICLE_ASSIGNMENT_RULE_BUSY"), true;

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign/${ruleId}`, config)
      .then(response => {
        commit("LOAD_ARTICLE_ASSIGNMENT_RULE_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_ASSIGNMENT_RULE_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_ASSIGNMENT_RULE_BUSY", false));
  },

  createAssignmentRule: ({ commit, rootState }, { projectId, assignmentRule }) => {
    commit("CREATE_ARTICLE_ASSIGNMENT_RULE_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const body = {
      ...assignmentRule
    };

    Axios.post(
      `${API_HOST}/analysis/${projectId}/auto_assign`,
      body,
      config
    )
      .then(response => {
        commit("CREATE_ARTICLE_ASSIGNMENT_RULE_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("CREATE_ARTICLE_ASSIGNMENT_RULE_FAIL", error);
      })
      .finally(() => commit("CREATE_ARTICLE_ASSIGNMENT_RULE_BUSY", false));
  },

  updateAssignmentRule: ({ commit, rootState }, { projectId, assignmentRule }) => {
    commit("UPDATE_ARTICLE_ASSIGNMENT_RULE_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const body = {
      ...assignmentRule
    };

    Axios.put(
      `${API_HOST}/analysis/${projectId}/auto_assign/${assignmentRule.id}`,
      body,
      config
    )
      .then(response => {
        commit("UPDATE_ARTICLE_ASSIGNMENT_RULE_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("UPDATE_ARTICLE_ASSIGNMENT_RULE_FAIL", error);
      })
      .finally(() => commit("UPDATE_ARTICLE_ASSIGNMENT_RULE_BUSY", false));
  },

  removeAssignmentRules: ({ commit, rootState }, { projectId, ruleIds }) => {
    commit("DELETE_ARTICLE_ASSIGNMENT_RULE_BUSY", true);

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    let deleteParam;
    if (_.isArray(ruleIds)) {
      deleteParam = `?ids=${JSON.stringify(ruleIds)}`
    }
    else {
      deleteParam = `/${ruleIds}`
    }

    Axios.delete(
      `${API_HOST}/analysis/${projectId}/auto_assign${deleteParam}`,
      config
    )
    .then(response => {
      commit("DELETE_ARTICLE_ASSIGNMENT_RULE_SUCCESS", ruleIds);
    })
    .catch(error => {
      Vue.notify({
        group: "store_notifications",
        type: "error",
        text: i18n.t("messages.request.error")
      });

      console.error(error);
      commit("DELETE_ARTICLE_ASSIGNMENT_RULE_FAIL", error);
    })
    .finally(() => commit("DELETE_ARTICLE_ASSIGNMENT_RULE_BUSY", false));
  },

  getAssignmentSocialPostTypes: ({ commit, rootState }, { projectId, pagination }) => {
    commit("LOAD_SOCIAL_POST_TYPE_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign/social_post_types`, config)
      .then(response => {
        commit("LOAD_SOCIAL_POST_TYPE_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_SOCIAL_POST_TYPE_FAIL", error);
      })
      .finally(() => commit("LOAD_SOCIAL_POST_TYPE_BUSY", false));
  },
  getAssignmentAIModels: ({ commit, rootState }, { projectId, pagination }) => {
    commit("LOAD_ARTICLE_AI_MODELS_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectId}/auto_assign/ai_models`, config)
      .then(response => {
        commit("LOAD_ARTICLE_AI_MODELS_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_AI_MODELS_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_AI_MODELS_BUSY", false));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};